/*
 * @Descripttion:
 * @version:
 * @Author: zhubaodong
 * @Date: 2021-12-02 16:28:41
 * @LastEditors: zhubaodong
 * @LastEditTime: 2021-12-02 19:48:59
 */
import day from "dayjs";
export function getOrderStatus(status: number) {
  switch (status) {
    case 0:
      return "已关闭";
    case 1:
      return "待支付";
    case 2:
      return "部分支付";
    case 3:
      return "支付完成";
    default:
      return "";
      break;
  }
}

export function getStatusColor(status: number) {
  switch (status) {
    case 0:
      return "gray";
    case 1:
      return "red";
    case 2:
      return "red";
    case 3:
      return "green";
    default:
      return "";
      break;
  }
}

export function getMallOrderStatus(status: string) {
  switch (+status) {
    case 0:
      return "";
    case 1:
      return "";
    case 2:
      return "";
    case 3:
      return "待发货";
    case 4:
      return "已发货";
    case 5:
      return "成功";
    case 6:
      return "失败";
    default:
      return "";
      break;
  }
}
export function getMallStatusColor(status: string) {
  switch (+status) {
    case 0:
      return "";
    case 1:
      return "";
    case 2:
      return "";
    case 3:
      return "yellow";
    case 4:
      return "blue";
    case 5:
      return "green";
    case 6:
      return "red";
    default:
      return "";
      break;
  }
}

export function formatTime(time: number, type: string) {
  let formatType = type ? type : "YYYY-MM-DD HH:mm";
  return (time && day.unix(time).format(formatType)) || "--";
}
